import {
  message,
  Layout,
  Button,
  Modal,
  ConfigProvider,
  Row,
  Input,
  InputNumber,
  Col,
  Rate,
} from 'antd'

import React, { useRef, useState } from 'react'
import indexStyles from './index.module.less'
import bannerimage from '../../static/image/aicoding.jpg'


import logoman1 from '../../static/image/avatarman1.png'
import logowoman1 from '../../static/image/avatarwoman1.png' 
import logoman2 from '../../static/image/avatarman2.png' 
import teamleaderavatar from '../../static/image/teamleader.jpg'

import knowimg from '../../static/image/knowpoint.jpg' 
import exerciseimg from '../../static/image/exercise.jpg' 
import caseimg from '../../static/image/cases.jpg'  

import courselearnimg from '../../static/image/courselearn.png' 
import onlineExpimg from '../../static/image/onlineexp.png' 
import aichatimg from '../../static/image/aichat.png'  

import Icon, { RightOutlined } from '@ant-design/icons'

import { ReactComponent as settingSvg } from '../../static/image/setting.svg'
import { ReactComponent as codingSvg } from '../../static/image/coding.svg'
import { ReactComponent as learningSvg } from '../../static/image/learning.svg'
import { ReactComponent as groupSvg } from '../../static/image/group.svg'
import { ReactComponent as chatSvg } from '../../static/image/chat.svg'
import { ReactComponent as dataSvg } from '../../static/image/data.svg'

import { ReactComponent as checkSvg } from '../../static/image/checkgreen.svg'

const settingIcon = (props:any) => (<Icon component={settingSvg} {...props} />)
const codingIcon = (props:any) => (<Icon component={codingSvg } {...props} />)
const learningIcon = (props:any) => (<Icon component={learningSvg} {...props} />)
const groupIcon = (props:any) => (<Icon component={groupSvg} {...props} />)
const chatIcon = (props:any) => (<Icon component={chatSvg } {...props} />)
const dataIcon = (props:any) => (<Icon component={dataSvg} {...props} />)

const checkIcon = (props:any) => (<Icon component={checkSvg} {...props} />)


import TextArea from 'antd/lib/input/TextArea'
import zhCN from 'antd/lib/locale/zh_CN'
import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '../../api/http-request'

import Draggable from 'react-draggable'
import { checkUserLogin } from '../common/user-center/user-info'

export interface Props {}
export const Index: React.FC<Props> = (props) => {
  const [name, setName] = useState('') //姓名
  const [phone, setPhone] = useState('') //手机号
  const [institute, setInstitute] = useState('') //学院
  const [position, setPosition] = useState('') //职位
  const [userCount, setUserCount] = useState(0) //使用人数/团队大小
  const [comment, setComment] = useState('') //备注信息
  const [direction, setDirection] = useState('') // 专业或研究方向
  const [isModalVisible, setIsModalVisible] = useState(false)

  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)


  const platformHighlights = [
    {
      icon: settingIcon,
      title:'专业实验环境',
      description:'提供稳定高效的在线实验环境，无需本地配置，一键启动，专注于实验教学本身。'

    },
    {
      icon: codingIcon,
      title:'实操题目测评',
      description:'支持编程题目在线运行与自动测评，即时反馈学习效果，提升实践教学质量。'

    },
    {
      icon: learningIcon,
      title:'边学边练体验',
      description:'理论学习与实践操作无缝衔接，打造沉浸式学习体验，强化知识吸收与技能掌握。'

    },
    {
      icon: groupIcon,
      title:'灵活课程组合',
      description:'平台提供的课程资源包括知识点和题库，教师可以随意进行组合建课，满足个性化教学需求。'

    },
    {
      icon: chatIcon,
      title:'智能问答支持',
      description:'通过AI问学功能，实现师生高效互动，及时解决学习问题，提升教学质量。'

    },
    {
      icon: dataIcon,
      title:'数据资源管理',
      description:'提供实验数据上传与管理功能，满足多样化实验教学需求，支持个性化实验设计。'

    },
  ]


  const teacherReviews = [
    {
        name:'张教授',
        avatar: logoman1,
        school:'计算机科学与技术系',
        review:'"爱数课平台极大地简化了我们的教学流程，特别是在线实验模块的Jupyter Notebook环境，让学生可以随时随地进行Python实践操作，教学效果显著提升。"',
        rating: 5
    },
        {
        name:'李同学',
        avatar:logowoman1,
        school:'数据科学专业大三',
        review:'"作为一名数据科学专业的学生，爱数课的资源帮了我很大忙。基于知识点的课程结构清晰，每个知识点都配有视频、实验和习题，边学边练的模式让我收获很大。"',
        rating: 4.5
    },
        {
        name:'王院长',
        avatar:logoman2,
        school:'人工智能学院',
        review:'"我们学院正在建设人工智能专业，爱数课团队提供的专业建设方案和课程体系为我们节省了大量时间和精力，他们的专业背景让我们非常信任。"',
        rating: 5
    },

  ]

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const handleOk = () => {
    //确认创建实验
    setIsModalVisible(false)
  }

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  const onDirectionChange = async (e: any) => {
    setDirection(e.target.value)
  }

  const onNameChange = async (e: any) => {
    setName(e.target.value)
  }
  const onPhoneChange = async (e: any) => {
    setPhone(e.target.value)
  }

  const onInstituteChange = async (e: any) => {
    setInstitute(e.target.value)
  }

  const onPositionChange = async (e: any) => {
    setPosition(e.target.value)
  }

  const onUserCountChange = async (value: number) => {
    setUserCount(value)
  }

  const onCommentChange = async (e: any) => {
    setComment(e.target.value)
  }

  const onCourseBtnClick = (e: any) => {
    setIsModalVisible(true)
  }

  const onExperienceBtnClick = (e: any) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      window.location.href = '/case'
    }
  }

  // 提交教学申请回调
  const userApplyCreateCallback = (response: any) => {
    message.destroy()
    if (response.is_ok) {
      message.success('申请信息提交成功')
    } else {
      message.error('申请信息提交失败，请稍候再试')
    }
  }

  //提交教学申请
  const onCourseSubmitBtnClick = (e: any) => {
    let validArr = [
      name,
      phone,
      institute,
      position,
      userCount,
      direction,
      comment,
    ]

    if (validArr.some((item) => !item)) {
      message.error('请填写完整信息')
      return
    }

    setIsModalVisible(false)
    sendHttpPostRequest(
      'account/api/user_apply_create/',
      {
        username: name,
        phone: phone,
        institute: institute,
        position: position,
        usercount: userCount,
        direction: direction,
        comment: comment,
        usage: 2,
        platform_id: 2, // 1-爱数科  2-爱数课
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      userApplyCreateCallback
    )
  }

  return (
    <Layout style={{minWidth:1200, background:'#fff'}}>
      {/**  顶部  */}
      <div className={indexStyles.topDiv}>

        <div className={indexStyles.decorationWrapper}>
          <div className={indexStyles.decoration1} ></div>
          <div className={indexStyles.decoration2}> </div>
          <div className={indexStyles.decoration3}></div>
          <div className={indexStyles.decoration4}></div>
        </div>


        <div className={indexStyles.innerDiv}>
          <Row wrap={false} align={"middle"}>
            <Col span={12}>
                <div>
                  <div className={indexStyles.topTitleWrapper}>
                    <div className={indexStyles.topTitle}>国内领先的</div>
                    <div className={indexStyles.topTitle} ><span style={{color: '#07c160'}}>数智专业</span>教学管理平台</div>
                  </div>

                  <div className={indexStyles.topDescription}>
                    理论与实践结合，以数据为基础，实际问题为导向的创新教学理念，助力院校大数据和人工智能专业建设。
                  </div>

                  <div style={{textAlign: 'left'}}>
                    <span className={indexStyles.BtnDark} onClick={onExperienceBtnClick} >立即体验</span>
                    <span className={indexStyles.BtnLight} style={{marginLeft:24}} onClick={onCourseBtnClick} >申请入驻</span>
                  </div>  

                  <div style={{color: '#4b5563', fontSize:14, marginTop:36, textAlign:'left'}}>全国500余所高校已入驻使用</div>

                </div>
            </Col>

            <Col span={12} style={{textAlign:'right'}}>
                <div style={{position:'relative'}}>
                  <div className={indexStyles.rightdecoration1}  ></div>
                  <div className={indexStyles.rightdecoration2} ></div>
                  <div className={indexStyles.rightdecoration3} ></div>
                  <img src={bannerimage} style={{height:'300px', borderRadius:8}} />
                </div>
            </Col>
          </Row>
        </div>
      </div>

      {/** 使用院校 */}
      <div className={indexStyles.collegeDiv}>
          <div className={indexStyles.innerDiv}>
            <div style={{width:768, marginLeft:'auto', marginRight:'auto'}}>
                <div style={{margin:'0 0 16px', fontSize:24, fontWeight:600,color:'#111827'}}>已服务全国500+高校</div>
                <div style={{margin:'0 0 24px', fontSize:16,color:'#4b5563'}} >我们的平台已入驻全国500余所高校，得到师生的广泛认可，帮助培养了大批具备实践能力的AI人才。</div>

                <div style={{background:'#fff', padding:5, borderRadius:5}}>
                    <span className={indexStyles.collegeLogo}><img style={{width:150}} src="http://backend.idatacourse.cn/static/college_logos/2022-05-10/%E5%8D%8E%E4%B8%AD%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6-01.svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img style={{width:150}} src="http://backend.idatacourse.cn/static/college_logos/2024-09-20/%E5%8D%97%E6%96%B9%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6-01.svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}} src="http://backend.idatacourse.cn/static/college_logos/2022-02-16/%E5%B1%B1%E8%A5%BF%E5%A4%A7%E5%AD%A6-01.svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}}src="http://backend.idatacourse.cn/static/college_logos/2022-04-13/%E5%8C%97%E4%BA%AC%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6-01.svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}}src="http://backend.idatacourse.cn/static/college_logos/2023-07-07/%E5%8C%97%E4%BA%AC%E4%BF%A1%E6%81%AF%E7%A7%91%E6%8A%80%E5%A4%A7%E5%AD%A6.svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}}src="http://backend.idatacourse.cn/static/college_logos/2022-09-29/%E5%A4%A9%E6%B4%A5%E5%B8%88%E8%8C%83%E5%A4%A7%E5%AD%A6-01.svg"></img></span>

                    <span className={indexStyles.collegeLogo}><img style={{width:150}} src="http://backend.idatacourse.cn/static/college_logos/2024-12-27/test.png"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}} src="http://backend.idatacourse.cn/static/college_logos/2022-02-14/%E6%B9%96%E5%8C%97%E6%B0%91%E6%97%8F%E5%A4%A7%E5%AD%A6-01.svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}}src="http://backend.idatacourse.cn/static/college_logos/2022-12-07/%E6%B9%96%E5%8C%97%E7%BB%8F%E6%B5%8E%E5%AD%A6%E9%99%A2-01.svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}}src="http://backend.idatacourse.cn/static/college_logos/2022-02-17/%E9%95%BF%E6%B1%9F%E5%A4%A7%E5%AD%A6-01(2).svg"></img></span>
                    <span className={indexStyles.collegeLogo}><img  style={{width:150}}src="http://backend.idatacourse.cn/static/college_logos/2024-04-11/%E6%B9%96%E5%8C%97%E5%B7%A5%E4%B8%9A%E5%A4%A7%E5%AD%A6-02.svg"></img></span>
                    <span className={indexStyles.collegeLogo} ><img  style={{width:150}}src="http://backend.idatacourse.cn/static/college_logos/2025-09-01/wuhandaxue.png"></img></span>

                    
                </div>

            </div>
          </div>  
      </div>

      {/** 平台特色  */}
      <div className={indexStyles.keyHighlightsDiv}>
        <div className={indexStyles.innerDiv}>

          <div className={indexStyles.sectionTitleDiv}>
            <div className={indexStyles.sectionTitle}>
                  平台特色
            </div>

            <div className={indexStyles.sectionDescription}>
                爱数课提供专业的在线实验环境，支持实操题目运行与测评，结合边学边练的沉浸式学习体验，助力数智专业教学创新
            </div>

          </div>

            <Row wrap={true} gutter={[33,32]} justify={'space-between'}>
              {platformHighlights?.map((highlight, index)=>(
                <Col span={8} key={index}>
                  <div className={indexStyles.highlightCard}>
                    <div style={{textAlign:'left', marginBottom: 24}}>
                      <span className={indexStyles.highlightCardIconWrapper}>
                        <Icon component={highlight?.icon}/>
                      </span>
                    </div>

                    <div className={indexStyles.highlightCardTitle}>{highlight?.title}</div>

                    <div className={indexStyles.highlightCardDesp}>{highlight?.description}</div>

                  </div>
                </Col>
              ))}
            </Row>


          
        </div>        
      </div>

      {/** 主要数字 */}
      <div className={indexStyles.keyNumbersDiv}>
        <div className={indexStyles.innerDiv}>
          <Row wrap={false} gutter={[32,32]} align={"middle"}>
            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <div className={indexStyles.keyNumberValue}>10+</div>
                <div className={indexStyles.keyNumberKey}>精品课程</div>
              </div>
            </Col>

            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <div className={indexStyles.keyNumberValue}>300+</div>
                <div className={indexStyles.keyNumberKey}>在线实验</div>
              </div>
            </Col>

            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <div className={indexStyles.keyNumberValue}>50000+</div>
                <div className={indexStyles.keyNumberKey}>师生用户</div>
              </div>
            </Col>

            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <div className={indexStyles.keyNumberValue}>500+</div>
                <div className={indexStyles.keyNumberKey}>合作院校</div>
              </div>
            </Col>
          </Row>
        </div>       
      </div>

      {/** 核心功能 */}      
      <div className={indexStyles.mainFeatureDiv}>
        <div className={indexStyles.innerDiv}>
          <div className={indexStyles.sectionTitleDiv}>
            <div className={indexStyles.sectionTitle}>
                  功能模块
            </div>

            <div className={indexStyles.sectionDescription}>
                爱数课包含多个功能模块，满足数智专业教学全流程需求
            </div>

          </div>

          <Row wrap={false} align={'middle'} style={{marginBottom:64}}>
            <Col span={12} style={{textAlign:'left'}}>
                <div >
                  <div className={indexStyles.featureTitle}>
                    在线实验
                  </div>

                  <div className={indexStyles.featureDivider}>

                  </div>

                  <div className={indexStyles.featureDescription}>
                      内置专业Jupyter Notebook实验环境，专为Python语言设计，一键运行，无需配置，让师生专注于教学内容而非环境搭建。提供丰富的实验指导和数据管理支持。
                  </div>

                  <div className={indexStyles.featureItem}>
                    < Icon component={checkIcon}/>  专业Jupyter Notebook环境，支持Python语言
                  </div>

                  <div className={indexStyles.featureItem}>
                      < Icon component={checkIcon}/> 完善的数据管理功能，支持数据上传
                  </div>

                  <div className={indexStyles.featureItem}>
                    < Icon component={checkIcon}/>  支持个性化实验设计与操作
                  </div>
                </div>
            </Col>

            <Col span={12} style={{textAlign:'left'}}>
                <div style={{marginLeft:40}}>
                  <img src={onlineExpimg} style={{height:'260px',width:'500px', borderRadius:8}} />
                </div>
            </Col>

          </Row>

          <Row wrap={false} align={'middle'} style={{marginBottom:64}}>

            <Col span={12} style={{textAlign:'left'}}>
                <div >
                  <img src={courselearnimg} style={{height:'260px', width:'500px',borderRadius:8}} />
                </div>
            </Col>

            <Col span={12} style={{textAlign:'left'}}>
                <div  style={{marginLeft:40}} >
                  <div className={indexStyles.featureTitle}>
                    课程学习
                  </div>

                  <div className={indexStyles.featureDivider}>

                  </div>

                  <div className={indexStyles.featureDescription}>
                      提供结构化的课程体系，由知识点组合而成，每个知识点包含视频、实验和配套习题。支持教师自定义课程内容，灵活组合知识点和题库，满足不同教学需求。
                  </div>

                  <div className={indexStyles.featureItem}>
                    < Icon component={checkIcon}/>  模块化课程设计，基于知识点灵活组合
                  </div>

                  <div className={indexStyles.featureItem}>
                      < Icon component={checkIcon}/> 多媒体教学资源，丰富学习体验
                  </div>

                  <div className={indexStyles.featureItem}>
                    < Icon component={checkIcon}/>  边学边练模式，理论与实践结合
                  </div>
                </div>
            </Col>



          </Row>

          <Row wrap={false} align={'middle'}>
            <Col span={12} style={{textAlign:'left'}}>
                <div >
                  <div className={indexStyles.featureTitle}>
                    数智讲堂 & AI问学
                  </div>

                  <div className={indexStyles.featureDivider}>

                  </div>

                  <div className={indexStyles.featureDescription}>
                      数智讲堂提供行业专家讲座和前沿技术分享，拓宽学生视野。AI问学功能利用智能问答系统，及时解答学生疑问，辅助教师教学。
                  </div>

                  <div className={indexStyles.featureItem}>
                    < Icon component={checkIcon}/>  不定期更新的专家讲座内容
                  </div>

                  <div className={indexStyles.featureItem}>
                      < Icon component={checkIcon}/> 24/7 AI智能问答，即时响应
                  </div>

                  <div className={indexStyles.featureItem}>
                    < Icon component={checkIcon}/>  专业领域知识覆盖全面
                  </div>
                </div>
            </Col>

            <Col span={12} style={{textAlign:'left'}}>
                <div style={{marginLeft:40}} >
                  <img src={aichatimg} style={{height:'260px',width:'500px', borderRadius:8}} />
                </div>
            </Col>

          </Row>


        </div>       
      </div>

      {/** 资源中心 */}
      <div className={indexStyles.resourceDiv}>
        <div className={indexStyles.innerDiv}>
          <div className={indexStyles.sectionTitleDiv}>
            <div className={indexStyles.sectionTitle}>
                  资源中心
            </div>

            <div className={indexStyles.sectionDescription}>
                提供丰富的教学资源，支持教师创建和管理个性化教学内容
            </div>

          </div>

          <Row wrap={false} align={'middle'} gutter={[32,32]}>
            <Col span={8}>
              <div className={indexStyles.resourceCard}>
                  <div className={indexStyles.resourceCardCoverDiv}>
                      <img src={knowimg}  style={{borderRadius:'12px 12px 0 0', height:192, width:'100%'}}></img>
                  </div>

                  <div className={indexStyles.resourceCardContentDiv}>
                    <Row wrap={false} align={'middle'}>
                      <Col span={12} style={{textAlign:'left'}}>
                        <div><span className={indexStyles.resourceCardLabel} > 知识点管理 </span></div>
                      </Col>

                      <Col span={12} style={{textAlign:'right'}}>
                        <div><span className={indexStyles.resourceCardLabelNumber} > 500+ </span></div>
                      </Col>
                    </Row>

                    <div className={indexStyles.resourceCardTitle}> 知识点资源库 </div>

                    <div className={indexStyles.resourceCardDescription}> 管理平台授权课程的知识点以及教师自己创建的知识点，每个知识点包含视频、实验和配套习题等完整教学内容。 </div>

                    <div className={indexStyles.resourceCardBottomDiv}> <span className={indexStyles.resourceCardLookBtn} onClick={()=>{window.open('/module')}}  >查看全部 <RightOutlined/></span> </div>

                  </div>
              </div>
            </Col>

            <Col span={8}>
              <div className={indexStyles.resourceCard}>
                  <div className={indexStyles.resourceCardCoverDiv}>
                      <img src={exerciseimg}  style={{borderRadius:'12px 12px 0 0', height:192, width:'100%'}}></img>
                  </div>

                  <div className={indexStyles.resourceCardContentDiv}>
                    <Row wrap={false} align={'middle'}>
                      <Col span={12} style={{textAlign:'left'}}>
                        <div><span className={indexStyles.resourceCardLabel} > 习题库管理 </span></div>
                      </Col>

                      <Col span={12} style={{textAlign:'right'}}>
                        <div><span className={indexStyles.resourceCardLabelNumber} > 5000+ </span></div>
                      </Col>
                    </Row>

                    <div className={indexStyles.resourceCardTitle}> 智能习题库 </div>

                    <div className={indexStyles.resourceCardDescription}> 管理平台授权课程的习题库以及教师自己创建的习题，支持按知识点、难度等多维度筛选，配备智能批改和解析功能。 </div>

                    <div className={indexStyles.resourceCardBottomDiv}> <span className={indexStyles.resourceCardLookBtn}  onClick={()=>{window.open('/exercise')}} >查看全部 <RightOutlined/></span> </div>

                  </div>
              </div>
            </Col>

            <Col span={8}>
              <div className={indexStyles.resourceCard}>
                  <div className={indexStyles.resourceCardCoverDiv}>
                      <img src={caseimg}  style={{borderRadius:'12px 12px 0 0', height:192, width:'100%'}}></img>
                  </div>

                  <div className={indexStyles.resourceCardContentDiv}>
                    <Row wrap={false} align={'middle'}>
                      <Col span={12} style={{textAlign:'left'}}>
                        <div><span className={indexStyles.resourceCardLabel} > 教学案例 </span></div>
                      </Col>

                      <Col span={12} style={{textAlign:'right'}}>
                        <div><span className={indexStyles.resourceCardLabelNumber} > 300+ </span></div>
                      </Col>
                    </Row>

                    <div className={indexStyles.resourceCardTitle}> 精品教学案例 </div>

                    <div className={indexStyles.resourceCardDescription}> 提供丰富的数智专业教学案例，涵盖多个应用领域，帮助教师丰富教学内容，提升教学质量。 </div>

                    <div className={indexStyles.resourceCardBottomDiv}> <span className={indexStyles.resourceCardLookBtn} onClick={()=>{window.open('/case')}} >查看全部 <RightOutlined/></span> </div>

                  </div>
              </div>
            </Col>
          </Row>


        </div>        
      </div>

      {/** 团队介绍 */}
      <div className={indexStyles.teamDiv}>
        <div className={indexStyles.innerDiv}>
          <div className={indexStyles.sectionTitleDiv}>
            <div className={indexStyles.sectionTitle}>
                  创始团队
            </div>

            <div className={indexStyles.sectionDescription}>
                拥有深厚的学术背景和丰富的教学经验，致力于推动数智专业教育发展
            </div>

          </div>

          <div className={indexStyles.teamContentwrapper}>
              <Row gutter={[32,32]} wrap={false} align={'middle'}>
                <Col flex="288px">
                  <div style={{border:'4px solid #fff', borderRadius:'50%', height:228, width: 228}}>
                    <img  height="220px" width="220px" style={{borderRadius:'50%'}} src={teamleaderavatar}></img>
                  </div>
                  <div style={{marginTop:10}} className={indexStyles.reviewName}>
                        欧高炎 博士
                  </div>
                  <div className={indexStyles.reviewSchool} >
                      北京大学计算机博士、计算数学博士后
                  </div>
                </Col>

               <Col flex="auto" style={{textAlign:'left'}}>
                  <div style={{marginLeft:32}}>
                    <div className={indexStyles.teamTitle}>专业的创始团队背景</div>
                    <div className={indexStyles.teamItem}> < Icon component={checkIcon}/> 曾任北京大数据协会副会长、中国计算机学会数据库专委会执行委员、阿里云MVP</div>
                    <div className={indexStyles.teamItem}> < Icon component={checkIcon}/> 参与了我国第一个数据科学专业——北京大学数据科学专业的建设 </div>
                    <div className={indexStyles.teamItem}> < Icon component={checkIcon}/> 创始人曾参与北京大学数据科学导引课程的授课工作 </div>
                    <div className={indexStyles.teamItem}> < Icon component={checkIcon}/> 参与北京师范大学走近数据科学课程的授课工作 </div>
                    <div className={indexStyles.teamItem}> < Icon component={checkIcon}/> 帮助全国百余所高校进行数据科学和人工智能专业人才培养方案的论证 </div>
                    <div className={indexStyles.teamItem}> < Icon component={checkIcon}/> 出版了国内第一本数据科学教材《数据科学导引》</div>
                  </div>   
                </Col>

              </Row>

          </div>


        </div>        
      </div>

      {/** 用户评价 */}
      <div className={indexStyles.reviewDiv}>
        <div className={indexStyles.innerDiv}>
          <div className={indexStyles.sectionTitleDiv}>
            <div className={indexStyles.sectionTitle}>
                  用户评价
            </div>

            <div className={indexStyles.sectionDescription}>
                来自全国各院校师生的真实反馈
            </div>

          </div>  

          <Row gutter={[24,24]} >
            {teacherReviews?.map((tr, index)=>(
                <Col span={8} key={index}>
                    <div className={indexStyles.reviewCard}>

                        <div  className={indexStyles.reviewRating}>
                              <Rate allowHalf disabled defaultValue={tr?.rating} style={{fontSize:16,color:'#facc15'}}/>
                        </div>


                        <div  className={indexStyles.reviewContent}>
                            {tr?.review}
                        </div>

                        <Row wrap={false} align={'middle'} style={{margin:'0 0 24px'}}>
                            <Col flex={'52px'}>
                                <div>
                                    <div className={indexStyles.reviewLogoWrapper}>
                                        <img           
                                            style={{ width: 48, height: 48, borderRadius:'50%' }}
                                                src={
                                                    tr?.avatar
                                                }></img>
                                        
                                    </div>
                                </div>
                            </Col>

                            <Col flex={'auto'}>
                                <div style={{marginLeft:16}}>
                                    <div className={indexStyles.reviewName}>
                                        {tr?.name}
                                    </div>

                                    <div className={indexStyles.reviewSchool}>
                                          {tr?.school}
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </div>
                </Col>
            ))
            }
        </Row>


        </div>       
      </div>

      {/** 底部 */}      
      <div className={indexStyles.bottomDiv}>
        <div className={indexStyles.innerDiv}>
          <div className={indexStyles.sectionTitleDiv}>
            <div className={indexStyles.sectionTitle}>
                  开启数智教学新体验
            </div>

            <div className={indexStyles.sectionDescription}>
                加入爱数课，享受领先的数智专业教学管理平台，提升教学质量，培养高素质数智人才
            </div>
          </div>   

          <div style={{textAlign: 'center'}}>
            <span className={indexStyles.BtnDark} onClick={onExperienceBtnClick} >立即体验</span>
            <span className={indexStyles.BtnLight} style={{marginLeft:24}} onClick={onCourseBtnClick} >申请入驻</span>
          </div>      
        </div>      
      </div>


      <ConfigProvider locale={zhCN}>
        <Modal
          title={
            <div
              style={{
                width: '100%',
                cursor: 'move',
              }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false)
                }
              }}
              onMouseOut={() => {
                setDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
              // end
            >
              教学申请
            </div>
          }
          closable={true}
          open={isModalVisible}
          footer={null}
          onOk={handleOk}
          onCancel={handleCancel}
          bodyStyle={{ height: '500px' }}
          destroyOnClose={true}
          width={600}
          modalRender={(modal) => (
            <div className={indexStyles.applyDiv}>
              <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
              >
                <div ref={draggleRef}>{modal}</div>
              </Draggable>{' '}
            </div>
          )}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30 }}>
            自由组课，海量实操题库，作业、考试，解锁更多丰富的教师教学功能和资源，请填写以下信息，会有专员与您联系。
          </div>
          <div style={{ padding: 30 }}>
            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col flex="100px" style={{ textAlign: 'left' }}>
                真实姓名
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  onChange={onNameChange}
                  maxLength={20}
                  placeholder={'请输入您的姓名'}
                  required={true}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col flex="100px" style={{ textAlign: 'left' }}>
                手机号
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  onChange={onPhoneChange}
                  maxLength={11}
                  placeholder={'请输入手机号'}
                  required={true}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col flex="100px" style={{ textAlign: 'left' }}>
                学校院系
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  onChange={onInstituteChange}
                  maxLength={40}
                  placeholder={'所在学校和院系'}
                  required={true}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col flex="100px" style={{ textAlign: 'left' }}>
                专 业
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  onChange={onDirectionChange}
                  maxLength={40}
                  placeholder={'授课专业'}
                  required={true}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col flex="100px" style={{ textAlign: 'left' }}>
                职 务
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  onChange={onPositionChange}
                  maxLength={40}
                  placeholder={
                    '输入您的职务（院长、系主任、专业负责人、授课教师）'
                  }
                  required={true}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col flex="100px" style={{ textAlign: 'left' }}>
                使用人数
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <InputNumber
                  style={{ width: 180 }}
                  onChange={onUserCountChange}
                  maxLength={5}
                  placeholder={''}
                  required={true}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col flex="100px" style={{ textAlign: 'left' }}>
                备 注
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <TextArea
                  onChange={onCommentChange}
                  maxLength={400}
                  placeholder={'请输入备注信息'}
                  required={false}
                />
              </Col>
            </Row>
          </div>
          <Row justify="center" align="middle">
            <Button
              type="primary"
              style={{
                marginTop: 20,
                borderRadius: 20,
                margin: 'auto',
                width: 200,
                height:36,
                textShadow:'none',
                boxShadow:'none'
              }}
              onClick={onCourseSubmitBtnClick}
            >
              {' '}
              提交{' '}
            </Button>
          </Row>
        </Modal>
      </ConfigProvider>
    </Layout>
  )
}

export default Index
